export default __webpack_public_path__ + "static/media/1843.4164d71d.png";